'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/yearsUntil.js
// module id = 616
// module chunks = 0